import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, Col } from 'react-bootstrap';

import { HelpPopOver } from '../../infrastructure/forms/help-tip-icon/HelpTipIcon';
import { ImageWithMissingProductFallback } from '../order-review/order-summary/ImageWithMissingProductFallback';
import { MoneyDisplay } from '../order-selection/starter-kit-selection/util-starter-kit/MoneyDisplay';
import { EnrollmentOrderItem } from '../order-selection/starter-kit-selection/model/EnrollmentOrderItem';
import { FaGift } from 'react-icons/fa';

interface KitGridItemProps {
  item: EnrollmentOrderItem;
  showDetailLink?: boolean;
  customImage?: string;
  newSlMode?: boolean;
}

export const PromoItemCard = observer<KitGridItemProps>(function KitGridItem({
  item,
  showDetailLink = false,
  customImage,
  newSlMode = false
}) {
  const { t } = useTranslation();
  console.log(item);
  return (
    <>
      {!newSlMode && (
        <Col key={item.partNumber} md={3} style={{ marginBottom: '20px' }}>
          <Card style={{ minHeight: '340px' }}>
            <div className="text-left bg-primary">
              <p className="text-white header-card-text m-1 h-56">{item.name}</p>
            </div>

            <Card.Body className="text-center">
              <span>
                <Button variant="link" className="p-2">
                  <ImageWithMissingProductFallback src={item.imageUrl!} isPromotional={item.isPromotional} />
                </Button>
              </span>
              {showDetailLink && (
                <Button variant="link">
                  <u>{t('Details')}</u>
                </Button>
              )}
            </Card.Body>
          </Card>

          <strong>
            <span className="pr-1">Price: </span>
            {item.priceWithTax > 0 && <MoneyDisplay price={item.priceWithTax} />}
            {item.priceWithTax === 0 && (
              <span>
                {t('Free')} <HelpPopOver label="WhyFree" />
              </span>
            )}
          </strong>
        </Col>
      )}
      {newSlMode && (
        <Col key={item.partNumber} md={3}>
          <Card className="sl-product-card sl-promo">
            <div className="sl-product-image">
              <FaGift />
            </div>
            <div className="sl-product-info">
              <p className="sl-product-title">{item.name}</p>
              <p className="sl-product-description">{item.shortDescription}</p>
              <p className="sl-product-price">
                Price:
                {item.priceWithTax > 0 && <MoneyDisplay price={item.priceWithTax} />}
                {item.priceWithTax === 0 && (
                  <span>
                    {t('Free')} <HelpPopOver label="WhyFree" />
                  </span>
                )}
              </p>
            </div>
          </Card>
        </Col>
      )}
    </>
  );
});
